module.exports = __webpack_public_path__ + "img/0-42.68926ae3.jpg";